const base = "https://vote.xandervarga.me/";
export default base;
